import styled from "styled-components";

const WrapperPostItem = styled.div<{ small?: boolean; noPadding?: boolean }>`
  padding-top: 20px;
  padding-right: ${({ noPadding }) => (noPadding ? `0` : `20px`)};
  padding-bottom: 10px;
  ${({ small }) =>
    small ? `margin-left: -20px; margin-right: -20px; width: auto;` : ""};
  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.palette.grey[100]};
  }
`;

export default WrapperPostItem;
